import { create } from "zustand";
import { IUserVCard } from "@/types/user.types";
import selectColorTypeVCard from "@/components/common/selectColorTypes";

export const useUserVcard = create<IUserVCard>((set) => ({
  data: {
    dynamic: "1",
    name: "",
    welcome_screen: "",
    welcome_path: "",
    image: "",
    image_name: "",
    image_type: "",
    image_path: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    company: "",
    job: "",
    street: "",
    street_number: "",
    state: "",
    country: "",
    website_url: "",
    summary: "",
    design_colors_primary: selectColorTypeVCard[0].color,
    design_colors_button: selectColorTypeVCard[0].buttonColor,
    longitude: -73.9855426,
    latitude: 40.7579747,
    address: "",
    socialItems: [],
  },
  config: {},
  socialTypes: [
    {
      icon: `/social-items/website.svg`,
      text: "Website",
      active: false,
      type: "website",
    },
    {
      icon: `/social-items/facebook.svg`,
      text: "Facebook",
      active: false,
      type: "facebook",
    },
    {
      icon: `/social-items/twitter.svg`,
      text: "Twitter",
      active: false,
      type: "twitter",
    },
    {
      icon: `/social-items/instagram.svg`,
      text: "Instagram",
      active: false,
      type: "instagram",
    },
    {
      icon: `/social-items/linkedin.svg`,
      text: "Linkedin",
      active: false,
      type: "linkedin",
    },
    {
      icon: `/social-items/youtube.svg`,
      text: "Youtube",
      active: false,
      type: "youtube",
    },
    {
      icon: `/social-items/wp.svg`,
      text: "Whatsapp",
      active: false,
      type: "whatsapp",
    },
    {
      icon: `/social-items/tg.svg`,
      text: "Telegram",
      active: false,
      type: "telegram",
    },
    {
      icon: `/social-items/snap.svg`,
      text: "Snapchat",
      active: false,
      type: "snapchat",
    },
    {
      icon: `/social-items/tiktok.svg`,
      text: "Tiktok",
      active: false,
      type: "tiktok",
    },
  ],
  setDeleteUserVcard: (val) => {
    set((state) => {
      delete state.data[val];

      return { ...state };
    });
  },
  setConfig: (val) =>
    set((state) => ({
      ...state,
      config: { ...state.config, val },
    })),
  destroyUserVcard: () => {
    set({
      data: {
        dynamic: "1",
        name: "",
        welcome_screen: "",
        welcome_path: "",
        image: "",
        image_name: "",
        image_type: "",
        image_path: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        company: "",
        job: "",
        state: "",
        street: "",
        street_number: "",
        country: "",
        website_url: "",
        summary: "",
        design_colors_primary: selectColorTypeVCard[0].color,
        design_colors_button: selectColorTypeVCard[0].buttonColor,
        longitude: -73.9855426,
        latitude: 40.7579747,
        address: "",
        socialItems: [],
      },
      config: {},
      socialTypes: [
        {
          icon: `/social-items/website.svg`,
          text: "Website",
          active: false,
          type: "website",
        },
        {
          icon: `/social-items/facebook.svg`,
          text: "Facebook",
          active: false,
          type: "facebook",
        },
        {
          icon: `/social-items/twitter.svg`,
          text: "Twitter",
          active: false,
          type: "twitter",
        },
        {
          icon: `/social-items/instagram.svg`,
          text: "Instagram",
          active: false,
          type: "instagram",
        },
        {
          icon: `/social-items/linkedin.svg`,
          text: "Linkedin",
          active: false,
          type: "linkedin",
        },
        {
          icon: `/social-items/youtube.svg`,
          text: "Youtube",
          active: false,
          type: "youtube",
        },
        {
          icon: `/social-items/wp.svg`,
          text: "Whatsapp",
          active: false,
          type: "whatsapp",
        },
        {
          icon: `/social-items/tg.svg`,
          text: "Telegram",
          active: false,
          type: "telegram",
        },
        {
          icon: `/social-items/snap.svg`,
          text: "Snapchat",
          active: false,
          type: "snapchat",
        },
        {
          icon: `/social-items/tiktok.svg`,
          text: "Tiktok",
          active: false,
          type: "tiktok",
        },
      ],
    });
  },
  setUserVcard: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setReorderSocial: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          socialItems: val,
        },
      };
    });
  },
  setDeleteSocialItem: (index, qrShowId) => {
    set((state) => {
      const afterDeleted = state.data.socialItems.filter((e, i) => {
        if (qrShowId) {
          if (qrShowId) {
            e.id = e.id > 0 ? e.id - 1 : e.id;
          }
        }

        return i !== index;
      });

      return {
        ...state,
        data: {
          ...state.data,
          socialItems: afterDeleted,
        },
      };
    });
  },
  setSocialItems: (val, type, index, action) => {
    set((state) => {
      if (type === "add") {
        return {
          ...state,
          data: {
            ...state.data,
            socialItems: [...state.data.socialItems, val],
          },
        };
      }
      if (type === "update_value" && action) {
        (state.data.socialItems[index] as any)[action] = val;
        return { ...state };
      } else {
        return { ...state, socialItems: val };
      }
    });
  },
  setSocialTypes: (val) => {
    set((state) => {
      const newSocialTypesState = state.socialTypes.map((obj) => {
        if (
          obj.type.toUpperCase().replace(/\s+/g, "") === val.type.toUpperCase().replace(/\s+/g, "")
        ) {
          return { ...obj, active: val.active };
        }

        return obj;
      });

      return { ...state, socialTypes: newSocialTypesState };
    });
  },
  setDeleteSocialTypes: (val) => {
    set((state) => {
      const deleted = state.data.socialItems.filter(
        (e) =>
          e.type.toUpperCase().replace(/\s+/g, "") !== val.type.toUpperCase().replace(/\s+/g, ""),
      );

      delete state.data[val.type as keyof IUserVCard["data"]];

      return { ...state, socialItems: deleted };
    });
  },
}));
